// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ApartmentOutlinedSvg from "@ant-design/icons-svg/es/asn/ApartmentOutlined";
import AntdIcon from '../components/AntdIcon';

var ApartmentOutlined = function ApartmentOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ApartmentOutlinedSvg
  }));
};

ApartmentOutlined.displayName = 'ApartmentOutlined';
export default React.forwardRef(ApartmentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ApartmentOutlined.js
// module id = 571
// module chunks = 0